import { render, staticRenderFns } from "./MoveFundsForm.vue?vue&type=template&id=363b866b&scoped=true&"
import script from "./MoveFundsForm.vue?vue&type=script&lang=js&"
export * from "./MoveFundsForm.vue?vue&type=script&lang=js&"
import style0 from "./MoveFundsForm.vue?vue&type=style&index=0&id=363b866b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b866b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VForm,VIcon,VTooltip})
